import { theme } from '~/theme';
import {
  cssColorHexToRgbA,
  getBackgroundImage45DegLines,
} from '~/utils/helpers/css';

export const useSxStyles = () => {
  return {
    widgetContainer: {
      position: 'relative',

      '& > *:not($widget)': {
        zIndex: 2,
      },
    },
    movableWidgetContainer: {
      cursor: 'move',
    },
    widget: {
      width: '100%',
      height: '100%',
    },
    editableWidget: {
      pointerEvents: 'none',
      userSelect: 'none',

      '&::after': {
        content: '""',
        position: 'absolute',
        zIndex: 1,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
      },

      '&.unavailable::after': {
        backgroundImage: getBackgroundImage45DegLines(
          cssColorHexToRgbA(theme.palette.error.dark, 0.5),
          cssColorHexToRgbA(theme.palette.error.light, 0.5),
        ),
        backgroundSize: '8px 8px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },

      // Use static class for making some room for menu button
      '& .card-header': {
        marginRight: 30 + theme.spacing(),
      },
    },
    unavailableWidget: {
      display: 'flex',
      position: 'absolute',
      top: 0,
      height: '100%',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2,
    },
    unavailableWidgetMessage: {
      backgroundColor: 'rgba(255,255,255,0.5)',
      padding: theme.spacing(0.5, 1),
    },
    emptyWorkspace: {
      marginTop: '20vh',
      textAlign: 'center',
    },
    root: {
      '& .react-grid-item > .react-resizable-handle': {
        zIndex: 10,
        backgroundImage: 'none',
      },
      '& .react-grid-item > .react-resizable-handle:hover::after': {
        borderRightWidth: '3px',
        borderBottomWidth: '3px',
        width: '12px',
        height: '12px',
      },
      '& .react-grid-item > .react-resizable-handle::after': {
        zIndex: 10,
      },
      '& .react-grid-item.react-grid-placeholder': {
        backgroundColor: 'transparent',
        backgroundImage: getBackgroundImage45DegLines(
          theme.palette.success.main,
          'transparent',
        ),
        backgroundSize: '8px 8px',
      },
    },
  };
};
